import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [교환 신청/등록] 교환 재배송 처리 api 요청 훅
 */
const usePostExchangeOrdersExchangeReceiptIdOrder = () => {
  const { runAsync } = useAsyncHandler();

  const postExchangeOrdersExchangeReceiptIdOrder = useAPI({
    endpoint: API_ENDPOINT.CLAIM.POST_EXCHANGE_ORDERS_RESEND,
    method: 'post',
  });

  const resendExchangeOrders = async (
    {
      pathParams: { exchangeReceiptId },
    }: {
      pathParams: { exchangeReceiptId: string };
    },
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postExchangeOrdersExchangeReceiptIdOrder({ pathParams: `/${exchangeReceiptId}/order` }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { resendExchangeOrders };
};

export default usePostExchangeOrdersExchangeReceiptIdOrder;
